import { CalendarDays, ChevronDown } from 'lucide-react';
import type { InputHTMLAttributes } from 'react';

// A date / datetime input that reads as obviously tappable on iOS (where the
// native control otherwise renders as plain right-aligned text with no icon):
// calendar icon on the left, chevron on the right, a light tint, pointer cursor.
// Drop-in replacement for `<input type="date|datetime-local" className="input" ... />`.
type Props = InputHTMLAttributes<HTMLInputElement>;

export function DateField({ className = '', type = 'date', ...props }: Props) {
  return (
    <div className="relative">
      <CalendarDays
        size={17}
        className="pointer-events-none absolute left-3.5 top-1/2 -translate-y-1/2 text-navy-600"
      />
      <input
        {...props}
        type={type}
        className={`input cursor-pointer bg-sky-50/60 pl-10 pr-9 font-medium text-navy-900 ${className}`}
      />
      <ChevronDown
        size={16}
        className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-navy-500"
      />
    </div>
  );
}
